module.exports = __webpack_public_path__ + "img/buynow.23e7350c.svg";